import React, { type FunctionComponent } from 'react';
import { makeStyles } from '@mui/styles';
import { Drawer, closeDrawer, useGlobalization } from '@innovyze/stylovyze';

export enum HELP_DRAW {
	OVERVIEW = 'overviewHelpDraw',
	CONFIGURE = 'configureHelpDraw',
}

export const getHelpURL = (type: HELP_DRAW) => {
	switch (type) {
		case HELP_DRAW.OVERVIEW:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-7E41E395-4BF0-4C77-806D-5310F9D26E2E';
		case HELP_DRAW.CONFIGURE:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-8085E296-3240-41D4-BD75-C0F996542E49';
	}
};

import { useDispatch } from 'react-redux';

interface HelpDrawerProps {
	drawerID: HELP_DRAW;
	onClose?: () => void;
}

const useStyles = makeStyles({
	drawer: {
		width: '34.5rem',
		zIndex: 1300,
		inset: 'unset',
	},
	iFrame: {
		height: 'calc(100% - 4px)',
		width: '100%',
	},
});

const HelpDrawer: FunctionComponent<HelpDrawerProps> = ({
	drawerID,
	onClose,
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { t } = useGlobalization();

	const close = () => {
		dispatch(closeDrawer());
		onClose?.();
	};

	return (
		<Drawer
			drawerId={drawerID}
			onClose={close}
			className={classes.drawer}
			hideBackdrop
			disableEnforceFocus
			padContent={false}
			action={{
				label: t('Close'),
				onClick: close,
			}}>
			<iframe
				src={getHelpURL(drawerID)}
				title="Help page"
				className={classes.iFrame}></iframe>
		</Drawer>
	);
};

export default HelpDrawer;
